import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { ActivityLog, Copy, DocumentCheckmark, Download, Edit, EmailSent, Eye, LinkIcon, Trash } from 'seagull/icons';
import { Intent } from '~/infra/access-control';
export const approveOnBehalfTooltip = (param)=>{
    let { payload, isSample, expired, texts } = param;
    if (payload.withdrawnForEditing) return texts.approveOnBehalfWithdrawnTooltip();
    if (expired) return texts.approveOnBehalfExpiredTooltip();
    if (isSample) return texts.approveOnBehalfSampleTooltip();
    if (payload.hasExplicitApprovalToS) return texts.approveOnBehalfExplicitApprovalTooltip();
    if (payload.hasServiceBundles) return texts.approveOnBehalfServiceBundlesTooltip();
    if (payload.hasOptionalServices) return texts.approveOnBehalfOptionalServicesTooltip();
    return undefined;
};
const vendorRowActions = (param)=>{
    let { proposal, expired, proposalActions, onViewProposal, onViewActivityLog, texts } = param;
    const heapId = proposal.isSample ? 'test-proposal' : 'proposals';
    const edit = proposalActions.getEditProposalAction(proposal, 'viewProposal');
    const copyLink = proposalActions.getCopyProposalLinkAction(proposal);
    const reminder = proposalActions.getSendProposalReminderAction(proposal.id, proposal.isSample);
    const duplicate = proposalActions.getDuplicateProposalAction(proposal.id, {
        isSampleProposal: proposal.isSample,
        draftId: proposal.draftId
    });
    return [
        {
            icon: Eye,
            label: texts.mainAction.view(),
            intent: Intent.VendorViewProposal,
            heapId: "".concat(heapId, "-review-btn"),
            onClick: ()=>onViewProposal(proposal),
            bi: {
                name: 'proposals_row_view_proposal'
            }
        },
        {
            icon: Edit,
            label: edit.text,
            intent: edit.intent,
            disabled: edit.disabled,
            onClick: edit.onClick,
            bi: {
                name: 'proposals_row_withdraw_to_edit'
            }
        },
        ...expired ? [] : [
            {
                icon: LinkIcon,
                label: copyLink.text,
                intent: copyLink.intent,
                onClick: copyLink.onClick,
                bi: {
                    name: 'proposals_row_copy_link'
                }
            },
            {
                icon: EmailSent,
                label: reminder.text,
                intent: reminder.intent,
                disabled: reminder.disabled,
                onClick: reminder.onClick,
                bi: {
                    name: 'proposals_row_send_reminder'
                }
            }
        ],
        {
            icon: Copy,
            label: duplicate.text,
            intent: duplicate.intent,
            disabled: duplicate.disabled,
            onClick: duplicate.onClick,
            bi: {
                name: 'proposals_row_duplicate'
            }
        },
        {
            icon: ActivityLog,
            label: texts.viewActivityLog(),
            onClick: ()=>onViewActivityLog(proposal),
            bi: {
                name: 'view_activity_log'
            }
        }
    ];
};
const approveOnBehalfRowActions = (param)=>{
    let { proposal, isVendor, expired, proposalActions, approveOnBehalf, refresh, texts, editInPlaceEnabled } = param;
    if (!isVendor || !editInPlaceEnabled || approveOnBehalf == null || approveOnBehalf.hasSignatureToS) return [];
    const approve = proposalActions.getApproveOnBehalfAction(_object_spread({
        id: proposal.id
    }, approveOnBehalf), refresh);
    if (approve == null) return [];
    return [
        {
            icon: DocumentCheckmark,
            label: approve.text,
            intent: approve.intent,
            disabled: approveOnBehalf.withdrawnForEditing || proposal.isSample || expired || approveOnBehalf.hasExplicitApprovalToS || approveOnBehalf.hasServiceBundles || approveOnBehalf.hasOptionalServices,
            tooltip: approveOnBehalfTooltip({
                payload: approveOnBehalf,
                isSample: proposal.isSample,
                expired,
                texts
            }),
            onClick: approve.onClick,
            bi: {
                name: 'proposals_row_approve_on_behalf'
            }
        }
    ];
};
const cancelRowActions = (param)=>{
    let { proposal, isVendor, proposalActions, refresh, onWithdraw } = param;
    if (!isVendor) return [];
    const cancel = proposalActions.getCancelProposalAction(proposal.id, refresh);
    return [
        {
            icon: Trash,
            label: cancel.text,
            intent: cancel.intent,
            destructive: true,
            onClick: ()=>onWithdraw({
                    relationshipId: proposal.id,
                    draftId: proposal.draftId
                }),
            bi: {
                name: 'proposals_row_cancel'
            }
        }
    ];
};
export const proposalRowActions = (deps)=>[
        ...deps.isVendor ? vendorRowActions(deps) : [],
        {
            icon: Download,
            label: deps.texts.downloadPdf(),
            onClick: ()=>deps.onDownloadPDF(deps.proposal),
            bi: {
                name: 'proposals_row_download_pdf'
            }
        },
        ...approveOnBehalfRowActions(deps),
        ...cancelRowActions(deps)
    ];
